import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import { Car, Shield, Lock } from 'lucide-react';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#070A12] text-white border-t border-[#1E293B] mt-auto" data-testid="main-footer">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="/euromoto_icon_512.png"
                alt="EuroMoto Logo"
                className="w-9 h-9 rounded-lg object-cover"
              />
              <span className="font-bold text-xl tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Euro<span className="text-[#FADB5F]">Moto</span><span className="text-[#FADB5F]/60 text-sm">.Online</span>
              </span>
            </Link>
            <p className="text-sm text-[#94A3B8] max-w-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-1 mt-4">
              {[...Array(12)].map((_, i) => (
                <span key={i} className="text-[#FADB5F] text-xs">&#9733;</span>
              ))}
            </div>
            {/* Security badges */}
            <div className="flex items-center gap-3 mt-4">
              <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#1E293B]/50 border border-[#1E293B]">
                <Lock className="w-3 h-3 text-green-400" />
                <span className="text-[10px] text-[#94A3B8] font-medium">SSL Secured</span>
              </div>
              <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#1E293B]/50 border border-[#1E293B]">
                <Shield className="w-3 h-3 text-[#FADB5F]" />
                <span className="text-[10px] text-[#94A3B8] font-medium">GDPR Compliant</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#94A3B8] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Navigation
            </h4>
            <ul className="space-y-2">
              <li><Link to="/listings" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('nav.listings')}</Link></li>
              <li><Link to="/listings?vehicle_type=cars_suvs" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('categories.cars_suvs')}</Link></li>
              <li><Link to="/listings?vehicle_type=trucks_buses" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('categories.trucks_buses')}</Link></li>
              <li><Link to="/listings?vehicle_type=motorcycles_bikes" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('categories.motorcycles_bikes')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#94A3B8] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Legal
            </h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/contact" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#94A3B8] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Account
            </h4>
            <ul className="space-y-2">
              <li><Link to="/login" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('nav.login')}</Link></li>
              <li><Link to="/register" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('nav.register')}</Link></li>
              <li><Link to="/create-listing" className="text-sm text-[#94A3B8] hover:text-white transition-colors">{t('nav.create')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E293B] mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#475569]">&copy; {year} EuroMoto. {t('footer.rights')}</p>
          <div className="flex items-center gap-4">
            <div className="flex gap-1 items-center">
              {[...Array(12)].map((_, i) => (
                <span key={i} className="text-[#FADB5F]/40 text-[10px]">&#9733;</span>
              ))}
            </div>
            <span className="text-[10px] text-[#475569]">Payments by Stripe</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
